/**
 * Header scroll functionality
 * Adds/removes 'scrolled' class to header when page is scrolled
 */
export default function initializeHeaderScroll() {
    const header = document.querySelector('.site-header');
    const mainContent = document.querySelector('.main-content');
    const isHomePage = document.body.classList.contains('home');
    
    if (!header) {
        return;
    }

    // Na stronie głównej ustawiamy margin-top dla main-content równy wysokości headera
    // Używamy CSS variable, aby uniknąć efektu "cofania" strony
    if (isHomePage && mainContent) {
        function updateMainContentMargin() {
            const headerHeight = header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }
        
        // Ustawiamy margin-top bardzo wcześnie, przed renderowaniem
        // Używamy requestAnimationFrame, aby wykonać to przed pierwszym renderem
        requestAnimationFrame(() => {
            updateMainContentMargin();
        });
        
        // Również ustawiamy natychmiast, jeśli DOM jest już gotowy
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', updateMainContentMargin);
        } else {
            updateMainContentMargin();
        }

        const headerObserver = new ResizeObserver(() => {
            updateMainContentMargin();
        });

        headerObserver.observe(header);

    }

    let lastScrollTop = 0;
    const scrollThreshold = 50; // Próg scrollowania w pikselach

    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > scrollThreshold) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    // Throttle scroll event for better performance
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // Check initial scroll position
    handleScroll();
}


